export const getStorageItem = (key) => localStorage.getItem(key);

export const setStorageItem = (key, value) => localStorage.setItem(key, value);

export const clearStorage = () => localStorage.clear();

export const clearStorageItem = (key) => localStorage.removeItem(key);
